import { PROOF } from '../../config/site';

export default function SocialProof() {
  return (
    <section className="py-16" style={{ background: 'var(--bg-3)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <p className="text-center eyebrow mb-10 reveal">Built for serious traders</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
          {PROOF.map((p, i) => (
            <div key={p.label} className="text-center reveal" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="font-display font-bold gold-text" style={{ fontSize: 'clamp(34px,4.5vw,52px)', letterSpacing: '-0.02em' }}>{p.value}</div>
              <div className="mt-1.5 text-[14px] text-[var(--muted)]">{p.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
